// React
import React, { Component } from "react";
import PropTypes from "prop-types";

class Notice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: true
    };
  }

  componentWillUnmount() {
    const { clearMessage } = this.props;

    return clearMessage();
  }

  handleCloseNotice = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const { clearMessage } = this.props;

    this.setState((prevState) => ({
      visible: !prevState.visible
    }));

    return clearMessage();
  };

  render() {
    const { message, title, type } = this.props;
    const { visible } = this.state;

    const iconClass =
      type === `danger` ? `fa-times` : type === `success` ? `fa-check` : `fa-warning`;

    return !visible ? null : (
      <div className={`alert alert-block alert-${type} fade in col-sm-8 col-sm-offset-2`}>
        <button type="button" className="close" onClick={this.handleCloseNotice}>
          ×
        </button>
        <i className={`fa ${iconClass}`} /> <strong>{title}</strong>
        {` `}
        {message}
      </div>
    );
  }
}

Notice.defaultProps = {
  clearMessage: () => {},
  message: ``,
  title: ``,
  type: `success`
};

Notice.propTypes = {
  clearMessage: PropTypes.func,
  message: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf([`danger`, `success`, `warning`])
};

export default Notice;
